export default "__VITE_ASSET__Ti7EyLns__"